import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { settingsAPI } from '../../services/api';

export const fetchSettings = createAsyncThunk('settings/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await settingsAPI.getAll();
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch settings');
  }
});

export const updateSettings = createAsyncThunk('settings/update', async (data, { rejectWithValue }) => {
  try {
    const response = await settingsAPI.update(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update settings');
  }
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => { state.loading = true; })
      .addCase(fetchSettings.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchSettings.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updateSettings.fulfilled, (state, action) => { state.data = action.payload; });
  },
});

export default settingsSlice.reducer;
